import Button from '@/atoms/buttons/Button';
import IconHeading from '@/molecules/headings/IconHeading/IconHeading';
import List from '@/molecules/lists/List';
import TextListItem from '@/molecules/lists/Text/TextListItem';
import { useScenarioContext } from '@/shared/providers/ScenarioProvider';
import Size from '@enums/Size';
import MoveDownIcon from '@mui/icons-material/MoveDownRounded';
import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
import useCanCreateScenario from '@pkg/access/designs/can/useCreateScenario';
import { DesignEntity } from '@/lib/enums';
import useScenarioList from './useScenarioList';

const ScenarioList = ({ entityType, redirectToComparison }) => {
  const { routeToScenario, scenarios } = useScenarioList(
    entityType,
    redirectToComparison
  );

  const { create, scenario } = useScenarioContext();
  const canCreateScenario = useCanCreateScenario();
  const canCreate = canCreateScenario(scenario?.entity?.__type ?? entityType);
  const scenarioLabel = scenarios?.length > 1 ? 'scenarios' : 'scenario';
  const subtitle =
    scenarios?.length > 0
      ? `You have ${scenarios?.length} unpublished ${scenarioLabel}`
      : `You haven't created any scenarios`;

  const handleClick = (event, item) => {
    if (!item) {
      return;
    }

    const { scenario, designId } = item;

    if (redirectToComparison) {
      routeToScenario({
        entity: scenario.level,
        scenarioId: scenario.designId,
        designId,
      });
    } else {
      routeToScenario({ entity: scenario.level, designId: scenario.designId });
    }
  };

  const handleCreateScenario = async (event) => {
    if (!canCreate) return;
    const created = await create(event);
    if (!created) return;
    const { entity, scenarioId, designId } = created;

    if (redirectToComparison) {
      routeToScenario({ entity, scenarioId, designId });
    } else {
      routeToScenario({ entity, designId: scenarioId });
    }
  };

  return (
    scenarios && (
      <Grow in={true} timeout={500}>
        <div>
          <IconHeading
            color={entityType === DesignEntity.ROLE ? 'primary' : 'secondary'}
            icon={<MoveDownIcon />}
            size={Size.LARGE}
            subtitle={subtitle}
            title="Scenarios"
          />
          {scenarios?.length > 0 && (
            <Box mt={3}>
              <List
                items={scenarios}
                ListItem={<TextListItem />}
                onClick={handleClick}
              />
            </Box>
          )}
          <Box pl={scenarios?.length > 0 ? 0 : 9} pt={1}>
            <Button
              color="secondary"
              label="Create a scenario"
              disabled={!canCreate}
              onClick={handleCreateScenario}
              size={Size.SMALL}
            />
          </Box>
        </div>
      </Grow>
    )
  );
};

export default ScenarioList;
